import AdvertisementRow from "./AdvertisementRow"

export default  AdvertisementRow;
